import { CSSProperties } from "react"

export enum ListData_ValueTypes {
  Id = "Id",
  Div = "Div",
  Check = "Check",
  Number = "Number",
  String = "String",
  ProgressBar = "ProgressBar",
  List = "List",
  DeleteRowAction ="DeleteRowAction",
  SelectRowAction = "SelectRowAction",
  Button = "Button"
}

export interface SelectFieldOption_Values {
  id?: number
  label: string
  domain?:string
  style?: CSSProperties
}

export interface DataValue {
  type?:  ListData_ValueTypes,
  value: string|number|boolean|any //TODO: Sorter virker kun når any eksisterer (Only for the old way)
  style?:CSSProperties,
  static?:boolean,
  select?:SelectFieldOption_Values[],
}
export type DataValue_Keys = keyof DataValue
export type Data = DataValue[]
export type ValueEdit = {row: number, col: number, value: any, key: string}

export enum penTypes {
  basic="basic",
  advanced="advanced",
  single="single",
  basicYesterday="basicYesterday",
  basicToday="basicToday"
}

export enum AttentionTypes {
  neutral = "System Off",
  good = "System Running",
  warning = "System Warning",
  alert = "System Alert",
}

export enum FeederStatus {
  idle="Idle",
  paused="Paused",
  dosing="Dosing",
  waiting="Waiting",
  measuring="Measuring",
  calibration="Waiting for Calibration",
  error="Error",
  off="Off"
}

export enum SystemTypes {
  AutoPig="AutoPig",
  LocationFeeder="Freeda Location Feeder",
  WalkThrough="Freeda Walk-Through",
  walkIn="Freeda Walk-In",
  ppt="Freeda PPT",
  sorter="Freeda Sorting"
}

export function numberConverter(data:number, format:number = 1000, padding:number = 2):string {
  var result = (Math.round(data)/format).toFixed(padding);
  return result;
}